import { useQuery } from "@apollo/client";
import { GET_GALLERY_PHOTOS } from "../queries";
import GalleryCard from "./gallery-card";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

interface ImageSize {
  name: string;
  sourceUrl: string;
}

interface GalleryImageNode {
  id: string;
  sourceUrl: string;
  altText?: string;
  mediaDetails?: {
    sizes: ImageSize[];
  };
}

export interface GalleryPhoto {
  id: string;
  title: string;
  slug: string;
  author: {
    node: {
      name: string;
    };
  };
  galleryFields: {
    galleryDescription: string;
    galleryPhotos: {
      nodes: GalleryImageNode[];
    };
  };
}

function Gallery() {
  const perPage = 20;
  const [after] = useState<String | null>(null);

  const {
    loading: loadingPhotos,
    data: photosData,
    error: photosError,
  } = useQuery(GET_GALLERY_PHOTOS, {
    variables: { first: perPage, after: after },
  });

  console.log(photosData);

  const photos: GalleryPhoto[] = photosData?.galleries?.nodes;

  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-center text-5xl font-semibold font-heading mb-4">
        Gallery
      </h1>

      {loadingPhotos &&
        Array.from({ length: perPage }).map((_, index) => (
          <div className="col-sm-6" key={index}>
            <h1 className="text-center">
              <Skeleton />
            </h1>
            <div className="gallery-image-skeleton">
              <Skeleton height="500px" width="900px" />
            </div>
          </div>
        ))}
      {photosError && (
        <>
          <h2 className="text-center">There was an error loading the posts!</h2>
          <p>
            <strong>{photosError.message}</strong>
          </p>
        </>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 w-full mx-0">
        {photos &&
          photos.map((photo) => (
            <>
              <div className="p-5 w-full" key={photo.id}>
                <GalleryCard photo={photo} />
              </div>
            </>
          ))}
      </div>
    </div>
  );
}

export default Gallery;
